import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';

import PaymentGateway from 'hb-react/shared/apps/Events/components/EventRegistrationContainer/components/Payment/PaymentGateway';
import Layout from 'hb-react/shared/apps/Events/components/Layout/';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';

import { useNavigation } from './hooks/useNavigation';
import PaymentAccessController from './PaymentAccessController';
import EventRegistrationSidebar from '../EventRegistrationSidebar';

const EventPayment = () => {
  const navigate = useNavigate();
  const { event } = useEventContext();
  const navigation = useNavigation();

  const onSuccess = () => {
    // workaround for race condition bug in react-router-dom
    // bug: https://github.com/remix-run/react-router/pull/8929
    setTimeout(() => navigate('../success', { replace: true }), 0);
  };

  return (
    <Layout
      navigation={navigation}
      sidebar={<EventRegistrationSidebar event={event} withShoppingCard />}
    >
      <Box display="block">
        <Card width="100%">
          <Box font="h3-semibold">{__('Payment details')}</Box>
          <Divider mt={3} width="100%" />
          <PaymentGateway onSuccess={onSuccess} />
        </Card>
        <NavBar />
      </Box>
    </Layout>
  );
};

const EventPaymentContainer = () => (
  <PaymentAccessController>
    <EventPayment />
  </PaymentAccessController>
);

export default EventPaymentContainer;

const NavBar = () => {
  const { eventRegistrationPageLink } = useEventContext();

  return (
    <Box mt={6}>
      <Button
        onClick={() => (window.location.href = eventRegistrationPageLink)}
        variant="secondary"
      >
        {s__('Memberships|Go back to registration')}
      </Button>
    </Box>
  );
};
